<template>
  <div style="margin: 12px 12px 0px;">
    <index-chart></index-chart>
  </div>
</template>

<script>
import IndexChart from './salemodules/FinanceIndexChart'

export default {
  name: "financeAnylize",
  components: {
    IndexChart
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>